import { TooltipPositionerCallbackFunction } from "highcharts";
import { format } from "date-fns";

type Offsets = { x?: number, y?: number }
export const positionerWithOffset: (offset: Offsets) => TooltipPositionerCallbackFunction = (offsets) => {
    const { x: x0 = 0, y: y0 = 0 } = offsets
    return function (labelWidth, labelHeight, point) {
        const clientRect = this.chart.container.getBoundingClientRect()
        // @ts-ignore
        const { x , y } = this.chart.tooltip.getPosition(labelWidth, labelHeight, point)
        return {
            x: x + x0 - clientRect.left,
            y: y + y0 - clientRect.top
        };
    }
}
type NumFormatter = (n: number) => string | undefined
export function declineNumeral(number: number, titles: string[], formatNumber: NumFormatter = x => x.toString()) {
    const cases = [2, 0, 1, 1, 1, 2];
    return `${formatNumber(number)} ${titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]}`;
}

export const declineDays = (day: number, formatter?: NumFormatter) => declineNumeral(day, ['день', 'дня', 'дней'], formatter)